import QtdModulo from '../../ModulosCrefito/QtdModulo'
import Epi from '../../ModulosCrefito/Modulos/Epi'
import ParametrosAssistenciais from '../../ModulosCrefito/Modulos/ParametrosAssistenciais'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import ResponsavelFisc from '../../ModulosCrefito/Modulos/ResponsavelFisc'
import ProfissionaisNoEstabelecimento from '../../ModulosCrefito/Modulos/ProfissionaisNoEstabelecimento'
import Estagio from '../../ModulosCrefito/Modulos/Estagio'
import PessoaNaoHabilitada from '../../ModulosCrefito/Modulos/PessoaNaoHabilitada'
import SetoresAssistencia from '../../ModulosCrefito/Modulos/SetoresAssistencia'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Clinica = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="responsavelfisc" />
            <ResponsavelFisc modulo="responsavelfisc" />
            <QtdModulo texto="FISIOTERAPEUTAS QUE TRABALHAM NO ESTABELECIMENTO" modulo="profissionais" />
            <ProfissionaisNoEstabelecimento modulo="profissionais" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="parametros" />
            <ParametrosAssistenciais modulo="parametros" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="ESTÁGIO" modulo="estagios" />
            <Estagio modulo="estagios" />
            <QtdModulo texto="EXERCÍCIO ILEGAL" modulo="naohabilitada" />
            <PessoaNaoHabilitada modulo="naohabilitada" />
            <QtdModulo texto="SETORES DE ASSISTÊNCIA" modulo="assistencia" />
            <SetoresAssistencia modulo="assistencia" />
            <QtdModulo texto="EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL" modulo="epi" />
            <Epi modulo="epi" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Clinica